// Renders article body paragraphs: "## Heading", "- bullet" lists and **bold** inline text.
const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i} className="font-semibold text-white">{part.slice(2, -2)}</strong> : part
  );

export function ArticleBody({ body }) {
  const paragraphs = (body || "").split(/\n\s*\n/).filter(Boolean);
  return paragraphs.map((p, i) => {
    if (p.startsWith("## ")) {
      return (
        <h3 key={i} className="pt-4 font-oswald text-xl font-bold uppercase tracking-wider text-white sm:text-2xl">
          {p.replace(/^##\s+/, "")}
        </h3>
      );
    }
    const lines = p.split("\n");
    if (lines.every((l) => /^\s*[-*]\s+/.test(l))) {
      return (
        <ul key={i} className="ml-5 list-disc space-y-1.5 marker:text-[#1f63c9]">
          {lines.map((l, j) => <li key={j}>{inline(l.replace(/^\s*[-*]\s+/, ""))}</li>)}
        </ul>
      );
    }
    return <p key={i}>{inline(p)}</p>;
  });
}
